module.exports = __webpack_public_path__ + "img/g3.fcf70f28.png";